// extracted by mini-css-extract-plugin
module.exports = {"container":"SignalBadge_container__3LA-H","icon":"SignalBadge_icon__1j39_","badge":"SignalBadge_badge__2IxWQ"};